import { FC, ReactNode, useEffect, useState } from "react";
import {
    MDBBtn,
    MDBCol,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
} from "mdb-react-ui-kit";
import styles from "../../styles/search/Search.Search.module.scss";
import socialAndBrandSvg from "../../utils/svg-icon/socialAndBrand";

const TourDestinationsModalFilters: FC<{
    children: ReactNode;
    show: boolean;
    setShow: (el: boolean) => void;
}> = ({ children, show, setShow }) => {
    const [render, SetRender] = useState(false);

    useEffect(() => SetRender(true), []);

    const toggleShow = () => setShow(!show);

    return render ? (
        <MDBModal
            show={show}
            setShow={setShow}
            tabIndex="-1"
            className={styles.modalBackground}
        >
            <MDBModalDialog className="p-4 p-sm-5 rounded-9">
                <MDBModalContent className="rounded-9">
                    <MDBModalHeader className="border border-0">
                        <MDBBtn
                            floating
                            className={`btn-close me-2 mt-2 border border-2 ${styles.modalCloseButton}`}
                            color="none"
                            onClick={toggleShow}
                        />
                    </MDBModalHeader>
                    <MDBModalBody className="px-4">
                        <MDBCol
                            className="d-flex justify-content-center"
                            size={12}
                        >
                            {children}
                        </MDBCol>
                    </MDBModalBody>

                    <MDBModalFooter className="justify-content-center border border-0">
                        <MDBBtn
                            className={styles.filterActionButton}
                            onClick={toggleShow}
                        >
                            Apply filters
                            <div className="ps-2 pt-1">
                                <socialAndBrandSvg.SketchLine />
                            </div>
                        </MDBBtn>
                    </MDBModalFooter>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    ) : (
        <div>aa</div>
    );
};

export default TourDestinationsModalFilters;
